module.exports = __webpack_public_path__ + "static/media/IMG-20201016-WA0023.1ad84cd0.jpg";